import React from 'react';

const TabSwitcherSmall = ({
  tabs = [],
  activeTab,
  onTabChange,
  containerStyle = {},
  tabsListStyle = {},
  getTabTriggerStyle = () => ({}),
  iconStyle = {},
  labelStyle = {},
  tabContentStyle = {},
  children
}) => {
  return (
    <div style={containerStyle}>

      {/* Tab Navigation - Smaller Version */}
      <div style={{
        display: 'flex',
        borderBottom: '1px solid #e5e7eb',
        ...tabsListStyle
      }}>

        {tabs.map((tab) => {
          const isActive = activeTab === tab.value;

          return (
            <button
              key={tab.value}
              onClick={() => onTabChange(tab.value)}
              style={{
                padding: '8px 12px',
                border: 'none',
                borderBottom: isActive ? '2px solid #3b82f6' : '2px solid transparent',
                backgroundColor: 'transparent',
                color: isActive ? '#3b82f6' : '#6b7280',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: isActive ? '600' : '500',
                transition: 'all 0.2s ease',
                ...getTabTriggerStyle(isActive)
              }}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.currentTarget.style.color = '#374151';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.currentTarget.style.color = '#6b7280';
                }
              }}
            >
              <span style={labelStyle}>{tab.label}</span>
            </button>
          );
        })}
      </div>

      {/* Content Area */}
      <div style={tabContentStyle}>
        {children}
      </div>
    </div>
  );
};

export default TabSwitcherSmall;